module.exports = __webpack_public_path__ + "ec55f263e2b86bc0f28fff46b873d6df.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/SemiboldItalic/OpenSans-SemiboldItalic.woff?v=1.1.0
// module id = 999
// module chunks = 0